// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AbstractViewModel } from '@front/webmobile/ViewModels/AbstractViewModel';
import { DataCache } from '@shared/commons/DataCache';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { Resources } from '@shared/localizations/Resources';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { OrderUtils } from '@shared/utils/Trading/OrderUtils';
export class OrderInfoProps {
}
export class OrderInfoComponentView {
    constructor() {
        this.showRoute = false;
        this.sideClass = '';
        this.orderIdLabel = '';
        this.fOrderId = '';
        this.instrumentLabel = '';
        this.fInstrumentName = '';
        this.routeLabel = '';
        this.fRoute = '';
        this.orderTypeLabel = '';
        this.fOrderType = '';
        this.sideLabel = '';
        this.fSide = '';
        this.leverageLabel = '';
        this.fLeverage = '';
        this.isAllowOTHTrading = false;
    }
}
export class OrderInfoViewModel extends AbstractViewModel {
    get showRoute() {
        return this.componentView.showRoute;
    }
    set showRoute(value) {
        this.updateComponentView('showRoute', value);
    }
    get sideClass() {
        return this.componentView.sideClass;
    }
    set sideClass(value) {
        this.updateComponentView('sideClass', value);
    }
    get orderIdLabel() {
        return this.componentView.orderIdLabel;
    }
    set orderIdLabel(value) {
        this.updateComponentView('orderIdLabel', value);
    }
    get fOrderId() {
        return this.componentView.fOrderId;
    }
    set fOrderId(value) {
        this.updateComponentView('fOrderId', value);
    }
    get instrumentLabel() {
        return this.componentView.instrumentLabel;
    }
    set instrumentLabel(value) {
        this.updateComponentView('instrumentLabel', value);
    }
    get fInstrumentName() {
        return this.componentView.fInstrumentName;
    }
    set fInstrumentName(value) {
        this.updateComponentView('fInstrumentName', value);
    }
    get routeLabel() {
        return this.componentView.routeLabel;
    }
    set routeLabel(value) {
        this.updateComponentView('routeLabel', value);
    }
    get fRoute() {
        return this.componentView.fRoute;
    }
    set fRoute(value) {
        this.updateComponentView('fRoute', value);
    }
    get orderTypeLabel() {
        return this.componentView.orderTypeLabel;
    }
    set orderTypeLabel(value) {
        this.updateComponentView('orderTypeLabel', value);
    }
    get fOrderType() {
        return this.componentView.fOrderType;
    }
    set fOrderType(value) {
        this.updateComponentView('fOrderType', value);
    }
    get sideLabel() {
        return this.componentView.sideLabel;
    }
    set sideLabel(value) {
        this.updateComponentView('sideLabel', value);
    }
    get fSide() {
        return this.componentView.fSide;
    }
    set fSide(value) {
        this.updateComponentView('fSide', value);
    }
    get leverageLabel() {
        return this.componentView.leverageLabel;
    }
    set leverageLabel(value) {
        this.updateComponentView('leverageLabel', value);
    }
    get fLeverage() {
        return this.componentView.fLeverage;
    }
    set fLeverage(value) {
        this.updateComponentView('fLeverage ', value);
    }
    get isAllowOTHTrading() {
        return this.componentView.isAllowOTHTrading;
    }
    set isAllowOTHTrading(value) {
        this.updateComponentView('isAllowOTHTrading', value);
    }
    constructor() {
        super(OrderInfoComponentView);
    }
    initialize(props) {
        super.initialize(props);
        this.order = props.order;
        this.updateFields(props.order);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    update(props) {
        super.update(props);
        if (props.order !== this.order) {
            this.order = props.order;
            this.updateFields(props.order);
        }
    }
    localize() {
        this.orderIdLabel = Resources.getResource('screen.modifyOrder.orderNumber');
        this.instrumentLabel = Resources.getResource('screen.modifyOrder.instrument');
        this.routeLabel = Resources.getResource('screen.modifyOrder.route');
        this.leverageLabel = Resources.getResource('screen.modifyOrder.leverage');
        this.sideLabel = Resources.getResource('screen.modifyOrder.operation');
        this.orderTypeLabel = Resources.getResource('screen.modifyOrder.ordertype');
        this.updateFields(this.order);
    }
    updateFields(order) {
        if (isNullOrUndefined(order))
            return;
        const ins = order.Instrument;
        const buy = order.BuySell === OperationType.Buy;
        const orderTypeDict = DataCache.OrderParameterContainer.OrderTypes;
        const orderType = orderTypeDict[order.OrderType];
        this.showRoute = !ins.isHideRouteMode;
        this.fOrderId = order.OrderNumber;
        this.fSide = Resources.getResource('general.trading.' + (buy ? 'Buy' : 'Sell'));
        this.fLeverage = OrderUtils.GetFormattedLeverage(order.Leverage);
        this.fInstrumentName = ins.DisplayName();
        this.fRoute = ins.getRoute();
        this.fOrderType = Resources.getResource(orderType.localizationKey());
        this.sideClass = buy ? 'buy-color' : 'sell-color';
        this.isAllowOTHTrading = !isNullOrUndefined(order.IsAllowOTHTrading) && order.IsAllowOTHTrading;
    }
}
